import React from "react";

import t from "../../../../lib/translate";
import * as styles from "./component.module.less";

export function SeminarTeaserContent({ currentAppointment }) {
    if (!currentAppointment) {
        return null;
    }

    const {
        localizedStartDate,
        startTime,
        localizedEndDate,
        endTime,
        typeOfSeminar
    } = currentAppointment;

    return (
        <div className={styles.appointment}>
            {localizedStartDate === localizedEndDate ? (
                <span>{`${localizedStartDate} | ${startTime} - ${endTime}`}</span>
            ) : (
                <span>{`${localizedStartDate} ${startTime} - ${localizedEndDate} ${endTime}`}</span>
            )}
            <span>{t(`seminar.type.${typeOfSeminar}`)}</span>
        </div>
    );
}
